import script from "./BaseLink.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLink.vue?vue&type=script&setup=true&lang=js"

import "./BaseLink.vue?vue&type=style&index=0&id=315c9a2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-315c9a2e"]])

export default __exports__